import { gql } from '@apollo/client';

const schema = {
  payment: {
    name: "onlinePayment",
    serviceName: "auth",
    query: gql`
      mutation onlinePayment($amount: String!) {
        onlinePayment(amount: $amount) {
          online_payment_refId
          messages
        }
      }
    `,
  },
};

export default schema;
